module.exports = __webpack_public_path__ + "img/btn.587fc2e1.png";